"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getCompletionStatus_1 = require("../helpers/getCompletionStatus");
const getContentType_1 = require("../helpers/getContentType");
const getCompletionStatusUpdatedEvent_1 = require("../helpers/getEvent/getCompletionStatusUpdatedEvent");
const getRootContentIdFromState_1 = tslib_1.__importDefault(require("../helpers/getRootContentIdFromState"));
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
const calculateScaledProgressMeasure_1 = require("./helpers/calculateScaledProgressMeasure");
const getCompletionCriteriaForCardQuestionForReview_1 = require("./helpers/getCompletionCriteriaForCardQuestionForReview");
const getCompletionStatusForCheckpoint_1 = require("./helpers/getCompletionStatusForCheckpoint");
const getCompletionStatusForCurriculum_1 = require("./helpers/getCompletionStatusForCurriculum");
const getCompletionStatusForILT_1 = require("./helpers/getCompletionStatusForILT");
const getCompletionStatusForLeafNode_1 = require("./helpers/getCompletionStatusForLeafNode");
const getCompletionStatusForNonLeafNode_1 = require("./helpers/getCompletionStatusForNonLeafNode");
const getCompletionStatusForSession_1 = require("./helpers/getCompletionStatusForSession");
const issueCertificate_1 = tslib_1.__importDefault(require("./issueCertificate"));
function addScaledProgressMeasureAndCompletionStatus(content, user, states, state, resetProgressFlag) {
    if (state.forceComplete) {
        state.scaledProgressMeasure = 1.0;
        state.completionStatus = entity_1.CompletionStatus.COMPLETE;
        return;
    }
    state.scaledProgressMeasure = calculateScaledProgressMeasure_1.calculateScaledProgressMeasure(content.minProgressMeasure || 1, state.progressMeasure);
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.LEARNING_CARD:
        case entity_1.ContentType.PEER_QUESTION:
            state.completionStatus = getCompletionStatusForLeafNode_1.getCompletionStatusForLeafNode(content.completionCriteria, state.scaledProgressMeasure);
            break;
        case entity_1.ContentType.CARD_QUESTION:
            state.completionStatus = getCompletionStatusForLeafNode_1.getCompletionStatusForLeafNode(entity_1.CompletionCriteria.ACTUAL_SUBMIT, state.scaledProgressMeasure, state.actualSubmit);
            break;
        case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW:
            const completionCriteria = getCompletionCriteriaForCardQuestionForReview_1.getCompletionCriteriaForCardQuestionForReview(content);
            state.completionStatus = getCompletionStatusForLeafNode_1.getCompletionStatusForLeafNode(completionCriteria, state.scaledProgressMeasure);
            break;
        case entity_1.ContentType.ASSIGNMENT_CARD:
        case entity_1.ContentType.PEER_REVIEW_CARD:
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE:
            state.completionStatus = getCompletionStatusForNonLeafNode_1.getCompletionStatusForNonLeafNode(state, user, content, states, resetProgressFlag);
            break;
        case entity_1.ContentType.CURRICULUM:
            state.completionStatus = getCompletionStatusForCurriculum_1.getCompletionStatusForCurriculum(state, user, content, states);
            break;
        case entity_1.ContentType.CHECKPOINT:
            state.completionStatus = getCompletionStatusForCheckpoint_1.getCompletionStatusForCheckpoint(state);
            break;
        case entity_1.ContentType.ILT:
            state.completionStatus = getCompletionStatusForILT_1.getCompletionStatusForILT(state, states);
            break;
        case entity_1.ContentType.ILT_SESSION:
            state.completionStatus = getCompletionStatusForSession_1.getCompletionStatusForSession(state);
            break;
        default:
            break;
    }
}
/**
 * Calculates scaledProgressMeasure and then updates
 * completionStatus if required. Considers forceComplete
 * flag while updating scaledProgressMeasure. Returns
 * completionStatusUpdated event if completion status is
 * updated.
 */
function updateCompletionStatus(command, user, content, states, resetProgressFlag) {
    const events = [];
    const { timeStamp } = command;
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const currentCompletionStatus = state.completionStatus;
    const contentType = getContentType_1.getContentType(content);
    addScaledProgressMeasureAndCompletionStatus(content, user, states, state, resetProgressFlag);
    if (currentCompletionStatus !== state.completionStatus) {
        if (currentCompletionStatus === entity_1.CompletionStatus.NOT_ATTEMPTED) {
            state.startedOn = timeStamp;
        }
        if (state.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            state.completedOn = timeStamp;
            issueCertificate_1.default(command, user, content, states);
        }
        const { userId, companyId } = user;
        const rootContentId = getRootContentIdFromState_1.default(state);
        const currentCompletionStatusEnum = getCompletionStatus_1.getCompletionStatus(currentCompletionStatus);
        const updatedCompletionStatusEnum = getCompletionStatus_1.getCompletionStatus(state.completionStatus);
        const completionStatusUpdatedEvent = getCompletionStatusUpdatedEvent_1.getCompletionStatusUpdatedEvent(command, companyId, userId, content._id, contentType, currentCompletionStatusEnum, updatedCompletionStatusEnum, rootContentId);
        events.push(completionStatusUpdatedEvent);
    }
    return events;
}
exports.updateCompletionStatus = updateCompletionStatus;
//# sourceMappingURL=updateCompletionStatus.js.map